import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import Hero from './components/Hero';
import Features from './components/Features';
import PopularComics from './components/PopularComics';
import CalendarPreview from './components/CalendarPreview';
import Testimonials from './components/Testimonials';
import FaqPreview from './components/FaqPreview';
import CtaSection from './components/CtaSection';

export default function Home() {
  usePageMeta(
    '我爱漫画网 - 追更收藏漫画 | 连载更新提醒与追漫日历',
    '我爱漫画网是漫画迷必备的追更收藏站。收藏漫画、连载更新提醒、追漫日历、进度保存一应俱全，养肥再看有进度保存，更新推送不错过每一话。'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <PopularComics />
        <CalendarPreview />
        <Testimonials />
        <FaqPreview />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}